import React, { useRef } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AuthShell from "./AuthShell";
import { carryFrom } from "./authUtils";
import ForgotCard from "./ForgotCard";
import LoginCard from "./LoginCard";
import SignupCard from "./SignupCard";
import VerifyCard from "./VerifyCard";

/** Mounted at /auth/*: login, signup, forgot, verify. App.jsx handles signed-in-and-verified redirects. */
export default function AuthRoutes() {
  const { user, emailVerified } = useAuth();
  const { pathname, state } = useLocation();
  const signupBusy = useRef(false);

  const onVerify = pathname.startsWith("/auth/verify");
  if (!user && onVerify) return <Navigate to="/auth/login" replace state={carryFrom(state)} />;
  // Signed in but unverified: only the verify card makes sense (signup navigates itself while submitting).
  // Keep `from` so verifying lands on the page they originally opened (App.jsx returnPath).
  if (user && !emailVerified && !onVerify && !signupBusy.current) return <Navigate to="/auth/verify" replace state={{ from: state?.from }} />;

  return (
    <AuthShell>
      <Routes>
        <Route path="login" element={<LoginCard />} />
        <Route path="signup" element={<SignupCard busyRef={signupBusy} />} />
        <Route path="forgot" element={<ForgotCard />} />
        <Route path="verify" element={<VerifyCard />} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>
    </AuthShell>
  );
}
